<template>
   <div class="task-pagination">
      <button class="nav-btn" :disabled="currentPage <= 1" @click="$emit('page-change', currentPage - 1)">
         <Icon name="arrow-left" />
         <span>Previous</span>
      </button>

      <div class="page-numbers">
         <template v-for="(page, i) in visiblePages">
            <span v-if="page === '...'" :key="`ellipsis-${i}`" class="ellipsis">...</span>
            <button
               v-else
               :key="page"
               class="page-btn"
               :class="{ 'page-btn--active': page === currentPage }"
               @click="$emit('page-change', page)"
            >
               {{ page }}
            </button>
         </template>
      </div>

      <button class="nav-btn nav-btn--next" :disabled="currentPage >= totalPages" @click="$emit('page-change', currentPage + 1)">
         <span>Next</span>
         <Icon name="arrow-right" />
      </button>
   </div>
</template>

<script>
import Icon from "@/components/atoms/Icon.vue";

export default {
   name: "TaskRequestPagination",
   components: { Icon },
   props: {
      currentPage: { type: Number, default: 1 },
      totalPages: { type: Number, default: 1 },
   },
   computed: {
      visiblePages() {
         const total = this.totalPages;
         const current = this.currentPage;

         if (total <= 7) {
            return Array.from({ length: total }, (_, i) => i + 1);
         }

         const pages = [1, 2, 3];
         if (current > 5) pages.push("...");

         const start = Math.max(4, current - 1);
         const end = Math.min(total - 3, current + 1);
         for (let i = start; i <= end; i++) {
            if (!pages.includes(i)) pages.push(i);
         }

         if (current < total - 4) pages.push("...");
         [total - 2, total - 1, total].forEach((p) => {
            if (!pages.includes(p) && p > 0) pages.push(p);
         });

         return pages;
      },
   },
};
</script>

<style lang="scss" scoped>
.task-pagination {
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 24px 0;
   border-top: 1.5px solid #dde1e6;

   .nav-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      border: none;
      background: transparent;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      color: #697077;
      padding: 4px;
      border-radius: 4px;

      &--next {
         color: #121619;
      }

      &:disabled {
         opacity: 0.4;
         cursor: not-allowed;
      }
   }

   .page-numbers {
      display: flex;
      align-items: center;
      gap: 8px;
   }

   .ellipsis {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 14px;
      color: #697077;
      font-size: 14px;
   }

   .page-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border: none;
      background: transparent;
      border-radius: 4px;
      cursor: pointer;
      font-size: 16px;
      color: #121619;
      font-weight: 400;

      &--active {
         background-color: #21272a;
         color: white;
         font-weight: 500;
         border-radius: 8px;
      }

      &:not(.page-btn--active):hover {
         background-color: var(--gray-100);
      }
   }
}
</style>
